import { computed } from "vue";
import { useStore } from "vuex";

/**
 * 管理员权限检查 composable
 * @returns {Object} 包含 isAdmin 计算属性
 */
export const useAdmin = () => {
  const store = useStore();
  const userInfo = computed(() => store.state.user.userInfo);
  const isDev = computed(() => store.state.user.is_dev);

  // 管理员邮箱列表
  const adminEmails = ["vanderwals@163.com", "jack.zhang@zhengyun.app"];

  // 判断是否是管理员
  const isAdmin = computed(() => {
    if (!userInfo.value?.email_address) {
      return false;
    }
    return (
      adminEmails.includes(userInfo.value.email_address) || isDev.value
    );
  });

  return {
    isAdmin,
    userInfo,
    isDev,
  };
};
